const targetAndCategoryValues = {
  south_african: ['white south africans', 'black south africans','umzulu','afrikaner','motswana','sotho','umlungu', 'colored  south africans', 'malay', 'umxhosa'],
  foreigner: ['bangladeshi','british','congolese', 'kenyans', 'indian','italian','mozambican', 'nigerians', 'somalians', 'zimbabweans'],
  good_person: ['job-promoter', 'doctor', 'lawyer', 'good-samaritan', 'philanthropist', 'police officer', 'humanitarian'],
  bad_person: ['job-stealer', 'murderer', 'rapist', 'troubled', 'burglarer', 'drug-trafficker', 'fraudster']
}

export default targetAndCategoryValues
